import { Box, Container, Grid, Paper } from '@material-ui/core'
import React from 'react'
import OrderStatus from '../common/OrderStatus'

const ManageOrderCard = ({ locationId }) => {
  return (
    <Paper color="secondary" square variant="outlined" style={{ borderRadius: '4px' }}>
      <Box paddingY={4}>
        <Container className="container">
          <Grid container justifyContent="center">
            <Grid item md={8} xs={12}>
              <OrderStatus locationId={locationId} />
            </Grid>
          </Grid>
        </Container>
      </Box>
    </Paper>
  )
}

export default ManageOrderCard
